import { NavigateFunction } from "react-router-dom";
import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

import { StatusBadge } from "@components";
import TableActions from "@components/TableActions";
import { CommitteeType } from "@type/procurements/committee";

export const CommitteeTableColumn = (
  t: TFunction<"translation", undefined>,
  language: string | null,
  navigate: NavigateFunction,
  openConfirmationModel: (itemName: string, id: string | number) => void,
) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("PROCUREMENT_COMMITTEE_TABLE.TABLE.COLUMN.COMMITTEE_NAME"),
      render: (name: string) => (
        <Text color="subtitle2" className="text-nowrap">
          {name}
        </Text>
      ),
    },
    {
      id: 2,
      key: "committeeMembers",
      name: t("PROCUREMENT_COMMITTEE_TABLE.TABLE.COLUMN.COMMITTEE_HEAD"),
      render: (committeeMembers: any) => {
        const committeeHead = committeeMembers?.find(
          (item: any) => item?.isCommitteeHead,
        );

        let committeeHeadName = committeeHead
          ? language
            ? language === "en"
              ? committeeHead?.employee?.nameEn
              : committeeHead?.employee?.nameBn
            : ""
          : "";

        return (
          <Text color="subtitle2" className="text-nowrap">
            {committeeHeadName}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "committeeMembers",
      name: t("PROCUREMENT_COMMITTEE_TABLE.TABLE.COLUMN.TOTAL_MEMBER"),
      render: (committeeMembers: any[]) => (
        <Text color="subtitle2" className="text-nowrap">
          {committeeMembers?.length}
        </Text>
      ),
    },
    {
      id: 4,
      key: "isActive",
      name: t("PROCUREMENT_COMMITTEE_TABLE.TABLE.COLUMN.STATUS"),
      render: (isActive: boolean) => (
        <StatusBadge status={isActive ? "active" : "inactive"} />
      ),
    },
    {
      id: 5,
      key: "id",
      name: "",
      render: (id: string | number, row: CommitteeType) => {
        return (
          <TableActions
            onClickEdit={() => {
              navigate(`${id}`);
            }}
            onClickDelete={() => openConfirmationModel(row?.name, id)}
          />
        );
      },
    },
  ];
};
